import NewVehicleFormApp from '../../auto/components/Forms/NewVehicleForm';
import FiatV2GalleriesSwitch from '../../auto/components/FiatV2GalleriesSwitch';
import DirectSalesCarousel from '../../auto/components/Carousels/FiatV2/DirectSales';
import DetailTabs from '../../auto/components/DetailTabs';
import AccordionVehicle from '../../auto/components/AccordionVehicle';
import TimeMissingFiatV2 from '../../auto/components/TimeMissingFiatV2';

(() => {
  // Adicione aqui chaves:valor com os componentes que serão atribuídos ao escopo
  // global. Não passe eles pelo hyperscript (h) aqui pois a página que os usa
  // é quem deve compilá-lo com os pros.
  const components = {
    NewVehicleFormApp,
    FiatV2GalleriesSwitch,
    DirectSalesCarousel,
    DetailTabs,
    AccordionVehicle,
    TimeMissingFiatV2,
  };

  Object.keys(components).forEach(c => {
    window[c] = components[c];
  });
})();
